import React from 'react';
import { Alert, AlertColor, Box } from '@mui/material';
import { Notification } from './Notification';

interface NotificationsProps {
    notifications: Notification[];
    onRemove: (id: string) => void;
}

export function Notifications(props: NotificationsProps) {

    const { notifications, onRemove } = props

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '2rem',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                zIndex: 9999,
                width: '90%',
                maxWidth: '500px',
                pointerEvents: 'none'
            }}
        >
            {notifications.map((notif) => {
                const colorMap: Record<string, AlertColor> = {
                    info: 'success',
                    warning: 'warning',
                };

                return (
                    <Alert
                        key={notif.id}
                        severity={colorMap[notif.type]}
                        onClose={() => onRemove(notif.id)}
                        variant="filled"
                        sx={{
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            pointerEvents: 'auto'
                        }}
                    >
                        {notif.message}
                    </Alert>
                );
            })}
        </Box>
    );
};
